import {Errors, KAError} from "@khan/logging";

const EXECUTION_MEMO: Record<string, Promise<any>> = {};

/**
 * Execute an external script; return a Promise that resolves once executed.
 *
 * You can call this as many times as you want. It only loads the script the
 * first time. The same promise will be returned in subsequent calls.
 */
export function executeExternalScript(
    url: string,
    opts?: {
        bustCache?: boolean;
        dataDomainScript?: string;
    },
): Promise<void> {
    const bustCache = opts && opts.bustCache;
    if (bustCache) {
        delete EXECUTION_MEMO[url];
    }
    const dataDomainScript = opts && opts.dataDomainScript;

    return (EXECUTION_MEMO[url] =
        EXECUTION_MEMO[url] ||
        new Promise<void>((resolve, reject) => {
            // Logic copied from jQuery's getScript
            const head = document.getElementsByTagName("head")[0];

            const script = document.createElement("script");
            script.async = true;
            script.src = url;
            if (dataDomainScript) {
                script.setAttribute("data-domain-script", dataDomainScript);
            }

            // @ts-expect-error - TS2339 - Property 'onreadystatechange' does not exist on type 'HTMLScriptElement'.
            script.onload = script.onreadystatechange = () => {
                if (
                    !(script as any).readyState ||
                    /loaded|complete/.test((script as any).readyState)
                ) {
                    // @ts-expect-error - TS2339 - Property 'onreadystatechange' does not exist on type 'HTMLScriptElement'.
                    script.onload = script.onreadystatechange = null;

                    if (script.parentNode) {
                        script.parentNode.removeChild(script);
                    }

                    // For testing
                    (EXECUTION_MEMO[url] as any)._resolved = true;

                    resolve();
                }
            };

            script.onerror = () => {
                reject(new KAError(`Failed to load ${url}.`, Errors.NotFound));
            };

            head.insertBefore(script, head.firstChild);
        }));
}

export function executeExternalScriptUncached(url: string): Promise<void> {
    return executeExternalScript(url, {bustCache: true});
}
